import queryString from 'query-string';
import useRouter from './useRouter';

export const DEVICE_REQUEST_KEY = 'device';
export enum deviceTypeParams {
    DEVICE_IOSAPP = 'iosapp',
    DEVICE_ANDROIDAPP = 'androidapp',
    DEVICE_IPADAPP = 'ipadapp',
}

const useDeviceType = () => {
    const { location } = useRouter();
    const { search } = location;

    const queryParams = search ? queryString.parse(search) : {};
    const deviceType = queryParams[DEVICE_REQUEST_KEY];

    const isIOSApp = deviceType === deviceTypeParams.DEVICE_IOSAPP;
    const isAndroidApp = deviceType === deviceTypeParams.DEVICE_ANDROIDAPP;
    const isIpadApp = deviceType === deviceTypeParams.DEVICE_IPADAPP;
    const isMobileApp = isIOSApp || isAndroidApp;
    const isApp = isMobileApp || isIpadApp;

    return {
        isIOSApp,
        isAndroidApp,
        isIpadApp,
        isMobileApp,
        isApp,
    };
};

export default useDeviceType;
